// Tunable knobs for the Issues widget. Keep widget-specific thresholds here so
// they're easy to find + tweak without digging through the assembly logic.
export const CONFIG = {
  // Signal categories that define an "issue" (v1's isIssueAnnotation: the
  // user_dissatisfaction signals). A topic counts toward issues by how much it
  // co-occurs with signals in these categories.
  issueCategories: ["userDissatisfaction"],
  // ±% change vs the previous period before an issue reads rising/declining
  // (else stable). 20 = v1 parity (trendCalculator.TREND_THRESHOLD_PCT).
  trendThresholdPct: 20,
  // Max issue rows to render.
  maxIssues: 10,
};
